import { gql } from "@apollo/client";

export const CREATE_TOWER_MUTATION = gql`
  mutation CreateTower($towerData: TowerInput!) {
    createTower(towerData: $towerData) {
      tower {
        id
        w3w
        zonkeId
        vrmPortalId
        installDate
        numberChannels
        port
      }
    }
  }
`;
